import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';
import ProviderLogin from './screens/ProviderLogin';
import ProviderCard from './screens/ProviderCard';
import MyHealthSummary from './screens/MyHealthSummary';
import Loading from './components/loadingComponent';
import PrivateRoute from './components/PrivateRoute';
import * as Constant from '../constants/actionTypes';
import { firstLowerLetter } from './UtilsWeb';

const AsyncDigitalCard = Loadable({
  loader: () =>
    import(`.${Constant.SLASH}${Constant.SCREENS}${Constant.SLASH}${Constant.DIGITAL_CARD_LINK}`),
  loading: Loading,
});

const AsyncLanguage = Loadable({
  loader: () =>
    import(`.${Constant.SLASH}${Constant.SCREENS}${Constant.SLASH}${Constant.LANGUAGE_LINK}`),
  loading: Loading,
});

const AsyncNotFound = Loadable({
  loader: () =>
    import(`.${Constant.SLASH}${Constant.SCREENS}${Constant.SLASH}${Constant.NOT_FOUND_PAGE_LINK}`),
  loading: Loading,
});

const AsyncMyHealthSummary = Loadable({
  loader: () =>
    import(
      `.${Constant.SLASH}${Constant.SCREENS}${Constant.SLASH}${Constant.MY_HEALTH_SUMMARY_LINK}`
    ),
  loading: Loading,
});

// const AsyncProviderCard = Loadable({
//   loader: () =>
//     import(`.${Constant.SLASH}${Constant.SCREENS}${Constant.SLASH}${Constant.PROVIDER_CARD_LINK}`),
//   loading: Loading,
// });

const Routes = ({ isAuthenticated }) => (
  <Switch>
    {/* <Route
      exact
      path={`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_LOGIN_LINK)}`}
      component={AsyncProviderLogin}
    />
    <Route
      path={`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`}
      component={AsyncProviderCard}
    /> */}
    {/* <Route path={Constant.SLASH} component={AsyncProviderLogin} /> */}
    <Route exact path={`${Constant.SLASH}`} component={ProviderLogin} />
    <PrivateRoute
      path={`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`}
      component={ProviderCard}
      isAuthenticated={isAuthenticated}
    />
    <PrivateRoute
      path={`${Constant.SLASH}${firstLowerLetter(Constant.MY_HEALTH_SUMMARY_LINK)}`}
      component={MyHealthSummary}
      isAuthenticated={isAuthenticated}
    />
    <Redirect
      from={`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_LOGIN_LINK)}`}
      to={Constant.SLASH}
      component={ProviderLogin}
    />
    <Route
      path={`${Constant.SLASH}${firstLowerLetter(Constant.LANGUAGE_LINK)}`}
      component={AsyncLanguage}
    />
    <PrivateRoute
      path={`${Constant.SLASH}${firstLowerLetter(Constant.DIGITAL_CARD_LINK)}`}
      component={AsyncDigitalCard}
      isAuthenticated={isAuthenticated}
    />
    <PrivateRoute
      path={`${Constant.SLASH}${firstLowerLetter(Constant.MY_HEALTH_SUMMARY_LINK)}`}
      component={AsyncMyHealthSummary}
      isAuthenticated={isAuthenticated}
    />
    <Route component={AsyncNotFound} />
  </Switch>
);

Routes.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

export default Routes;
